module.exports = __webpack_public_path__ + "img/1574751423.1a7e53f5.jpg";